import { jsx as y } from "react/jsx-runtime";
import { clsx as c } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import e from "./roche-side-by-side.module.scss.js";
import { RocheUISideBySideVerticalAlignment as i, RocheUISideBySideHorizontalAlignment as s } from "./roche-side-by-side.type.js";
const l = ({
  horizontalAlignment: d = s.LEFT,
  verticalAlignment: o = i.MIDDLE,
  equalRatio: t = !1,
  children: r
}) => {
  const m = c(
    e["side-by-side"],
    d === s.RIGHT && e["side-by-side--right"],
    d === s.SPACE_BETWEEN && e["side-by-side--space-between"],
    o === i.TOP && e["side-by-side--top"],
    o === i.BOTTOM && e["side-by-side--bottom"],
    t && e["side-by-side--equal-ratio"]
  );
  return /* @__PURE__ */ y("div", { className: m, children: r });
};
export {
  l as RocheUISideBySide
};
